<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>

        <li class="breadcrumb-item active" aria-current="page">
            Sample Distribution to Distributors
        </li>
    </ol>
</nav>

<div class="row compact-content">
    <div class="col-xl-12">
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">
            @if (distributorType != 3) {
            <div class="row gx-3">
                <div class="col-md-8 col-12 mb-2 mb-md-0 py-2">
                    <h5 class="mb-0 text-dark fw-bold">
                        Sample Issued to
                        <span style="text-transform: capitalize; color:#003E53">
                            {{ distributorType == 1 ? 'Wholesaler' : 'Retailer' }}: {{ singleDistributor?.name }}
                        </span>
                    </h5>
                    <div class="d-flex flex-wrap justify-content-md-start mt-1 gap-2">
                        @if (singleDistributor?.email) {
                        <a class="text-muted small text-decoration-none d-flex align-items-center">
                            <i class="bi bi-envelope me-1 fs-7"></i>
                            <span class="text-truncate" style="max-width: 140px;">
                                {{ singleDistributor.email }}
                            </span>
                        </a>
                        }
                        @if (singleDistributor?.phone) {
                        <a class="text-muted small text-decoration-none d-flex align-items-center">
                            <i class="bi bi-telephone me-2 fs-7"></i>
                            {{ singleDistributor.phone }}
                        </a>
                        }
                    </div>
                </div>
            </div>
            } @else {
            <div class="row gx-3">
                <div class="col-md-8 col-12 mb-2 mb-md-0 py-2">
                    <h5 class="mb-0 text-dark fw-bold">
                        Sample Issued to
                        <span style="text-transform: capitalize; color:#003E53">
                            Customer
                        </span>
                    </h5>
                    <div class="d-flex flex-wrap justify-content-md-start mt-1 gap-2">
                        @if (singleDistributor?.name ) {
                        <a class="text-muted small text-decoration-none d-flex align-items-center">
                            <i class="bi bi-person me-1 fs-7"></i>
                            <span class="text-truncate" style="max-width: 140px;">
                                {{ singleDistributor.name }}
                            </span>
                        </a>
                        }

                    </div>
                </div>
            </div>
            }

            <hr class="m-0 p-o">
            <hr class="m-0 p-o">

            <div class="row">
                <div class="col-lg-3 mt-1">
                    <ng-select [items]="allCategoriesMini" bindLabel="name" bindValue="_id"
                        placeholder="Select Category" [(ngModel)]="sampleSearch.category" name="category"
                        (change)="sampleFilter($event)" [appendTo]="'body'" dropdownPosition="bottom">
                    </ng-select>
                </div>
                <div class="col-lg-3">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search By Sample Name</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.name" name="name" (input)="onNameInputChange($event)">
                    </mat-form-field>
                </div>
                <div class="col-lg-3">
                    <mat-form-field mappearance="outline" class="dense w-100">
                        <mat-label>Search By Barcode</mat-label>
                        <input matInput [(ngModel)]="sampleSearch.barCode" name="barCode"
                            (input)="onBarCodeInputChange($event)">
                    </mat-form-field>
                </div>
                <div class="col-lg-3">
                    <mat-form-field class="w-100" (click)="picker.open()">
                        <mat-label>Search By Issue Date</mat-label>
                        <mat-date-range-input [rangePicker]="picker">
                            <input matStartDate placeholder="Start" [(ngModel)]="sampleSearch.startdate" readonly />
                            <input matEndDate placeholder="End" [(ngModel)]="sampleSearch.enddate"
                                (dateChange)="sampleFilter($event)" readonly />
                        </mat-date-range-input>
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        @if (sampleSearch.startdate || sampleSearch.enddate) {
                        <mat-icon matSuffix (click)="clearDateRange()" class="clear-icon fs-7"
                            style="cursor: pointer;">close</mat-icon>
                        }
                        <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                </div>
            </div>

            @if (distributorType==1 || distributorType==2 ) {
            <div class="table-responsive">
                <table mat-table [dataSource]="samplesDataSource" class="mat-table table-bordered compact-table">
                    <ng-container matColumnDef="issuedGroup">
                        <th mat-header-cell *matHeaderCellDef colspan="4" class="text-center py-1">Issued</th>
                    </ng-container>

                    <ng-container matColumnDef="srno">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">#</th>
                        <td mat-cell *matCellDef="let row; let index = index" class="py-1">
                            {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Sample Name</th>
                        <td mat-cell *matCellDef="let element" class="text-nowrap py-1">
                            <div class="fw-medium">{{element.sampleId?.name}}</div>
                            <small class="text-muted fs-7">{{element?.categoryId.name}}</small>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sampleCode">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Bar Code</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element?.sampleId?.sampleCode}}</td>
                    </ng-container>

                    <ng-container matColumnDef="totalItems">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Quantity Assigned</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element?.quantityAssigned}}</td>
                    </ng-container>

                    <ng-container matColumnDef="leftItems">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Stock</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element?.quantityRemaining}}</td>
                    </ng-container>

                    <ng-container matColumnDef="issuedWHL">
                        <th mat-header-cell *matHeaderCellDef class="py-1">WHL</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element?.issuedToWHL}}</td>
                    </ng-container>

                    <ng-container matColumnDef="issuedRTL">
                        <th mat-header-cell *matHeaderCellDef class="py-1">RTL</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element?.issuedToRTL}}</td>
                    </ng-container>

                    <ng-container matColumnDef="issuedCus">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Cus.</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element?.issuedToCustomer}}</td>
                    </ng-container>

                    <ng-container matColumnDef="issuedTotal">
                        <th mat-header-cell *matHeaderCellDef class="py-1">Total</th>
                        <td mat-cell *matCellDef="let element" class="py-1">
                            {{element.issuedToWHL + element.issuedToRTL + element?.issuedToCustomer}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="limit">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Limit</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element?.distributorLimit}}</td>
                    </ng-container>

                    <ng-container matColumnDef="hold">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Hold</th>
                        <td mat-cell *matCellDef="let element" class="py-1">{{element?.holdToRTL + element?.holdToWHL}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="createdAt">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1">Issue Date</th>
                        <td mat-cell *matCellDef="let element" class="py-1">
                            <div>{{ element.createdAt | date:'dd/MM/yyyy' }}</div>
                            <small>{{ element.createdAt | date:'hh:mm a' }}</small>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef rowspan="2" class="py-1 text-center">
                            Sample <br> Forwarded
                        </th>
                        <td mat-cell *matCellDef="let element" class="py-1 text-center">
                            <i class="bi bi-box-arrow-up-right c_btn" role="button" aria-label="Forward" title="Forward"
                                [routerLink]="['/samples/distributedBy/distributors',element?.receiverDistributorId?._id, element?.sampleId?._id,distributorType]"></i>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="headerRowDef1; sticky: true" class="t_head"></tr>
                    <tr mat-header-row *matHeaderRowDef="headerRowDef2; sticky: true" class="t_head"></tr>
                    <tr mat-row *matRowDef="let row; columns: sampleDisplayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" [attr.colspan]="sampleDisplayedColumns.length">
                            No data available
                        </td>
                    </tr>
                </table>
            </div>
            }
            @else{
            <div class="table-responsive">
                <table mat-table [dataSource]="samplesDataSource"
                    class="mat-table table-bordered compact-table table-hover">
                    <ng-container matColumnDef="srno">
                        <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                        <td mat-cell *matCellDef="let row; let index = index">
                            {{ index + 1 + (paginator.pageIndex * paginator.pageSize) }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="sample">
                        <th mat-header-cell *matHeaderCellDef>Samples</th>
                        <td mat-cell *matCellDef="let element" class="text-nowrap">
                            <div>
                                <span class="fw-bold">{{ element.sampleId?.name }}</span><br>
                                <small class="text-muted">{{ element.categoryId?.name }}</small>
                            </div>
                        </td>

                    </ng-container>
                    <ng-container matColumnDef="barcode">
                        <th mat-header-cell *matHeaderCellDef>Bar Code</th>
                        <td mat-cell *matCellDef="let element" class="text-nowrap">
                            <div>
                                <span >{{ element.sampleId?.sampleCode }}</span><br>

                            </div>
                        </td>

                    </ng-container>

                    <ng-container matColumnDef="issuedByDistributorId">
                        <th mat-header-cell *matHeaderCellDef>Distributor</th>
                        <td mat-cell *matCellDef="let element">
                            Name : {{element.issuedByDistributorId?.name}}<br>
                            Email : {{element.issuedByDistributorId?.email}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="issuedQuantity">
                        <th mat-header-cell *matHeaderCellDef>Issued Quantity</th>
                        <td mat-cell *matCellDef="let element">{{element.issuedQuantity}}</td>
                    </ng-container>
                    <ng-container matColumnDef="limit">
                        <th mat-header-cell *matHeaderCellDef>Limit</th>
                        <td mat-cell *matCellDef="let element">{{element.sampleId?.maxIssueQuantityCustomer}}</td>
                    </ng-container>

                    <ng-container matColumnDef="issueByHold">
                        <th mat-header-cell *matHeaderCellDef>Issued By Hold</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.issueByHold ? 'Yes' : 'No' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="issuedAt">
                        <th mat-header-cell *matHeaderCellDef>Issued At</th>
                        <td mat-cell *matCellDef="let element">{{element.issuedAt | date}}</td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="customerSamplesdisplayedColumns" class="t_head"></tr>
                    <tr mat-row *matRowDef="let row; columns: customerSamplesdisplayedColumns;"></tr>
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell text-center" [attr.colspan]="customerSamplesdisplayedColumns.length">
                            No data available
                        </td>
                    </tr>
                </table>
            </div>
            }
            <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllSamples($event)">
            </mat-paginator>
        </app-card>
    </div>
</div>
